var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"header m-0 h-100",attrs:{"header":_vm.$t('privileges'),"header-tag":"header"}},[_c('Badge',{staticClass:"px-2 py-1 mb-1",attrs:{"variant":"primary","value":_vm.value.privileges}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }